import { createAsyncThunk } from '@reduxjs/toolkit';
import { levelTestService } from '@/services';
import { RootState } from '@/types/common';

const levelTestThunks = {
  fetchLevelTestQuestions: createAsyncThunk('level-test/testQuestions', async (_, { getState }) => {
    try {
      const state = getState() as RootState;
      const questions = await levelTestService.fetchLevelTestQuestions(state.auth.user);
      return questions.data.data;
    } catch (error) {
      throw error;
    }
  }),
  postLevelTestResult: createAsyncThunk(
    'level-test/levelTestResult',
    async (_, { getState, rejectWithValue }) => {
      try {
        const state = getState() as RootState;
        const levelTestResult = {
          questions: state.levelTest.answers,
          userId: state.auth.user?.id,
          activityId: state.levelTest.activity.activityId,
          topicId: 0,
          unitId: 0,
          correctAnswers: state.levelTest.correctAnswers,
          wrongAnswers: state.levelTest.wrongAnswers,
          isCompleted: true,
          questionsAnswered: 10,
          score: state.game.total_correctAnswers * 10,
          startTime: '2024-08-14T13:40:39.449',
          finishTime: '2024-08-14T13:41:48.745',
          firstName: state.auth.user?.metadata.firstName,
          lastName: state.auth.user?.metadata.lastName,
          groupId: state.auth.user?.metadata.organizationDetails.groupId || '',
          organizationId: state.auth.user?.metadata.organizationDetails.organizationId,
          email: state.auth.user?.metadata.email,
        };

        const result = await levelTestService.postLevelTestResult(state.auth.user, levelTestResult);

        return result;
      } catch (err: any) {
        console.log(err);
        return rejectWithValue(err.response?.data || err.message);
      }
    }
  ),
};

export default levelTestThunks;
